<template>
    <div class="fire-stations-page">
        <h1>Fire Stations</h1>
        <FireStationsMap />
    </div>
</template>

<script setup>
import { useHead } from '@vueuse/head'
import FireStationsMap from '../components/FireStationsMap.vue'

useHead({
    title: 'Toronto Fire Stations - Interactive Map',
    meta: [
        {
            name: 'description',
            content: 'Explore Toronto Fire Stations on an interactive map. View station locations, addresses, and unit information across the city.'
        },
        {
            name: 'keywords',
            content: 'Toronto fire stations, fire department locations, emergency services, fire safety, Toronto fire map'
        }
    ]
})
</script>

<style scoped>
h1 {
    margin-top: 0;
    margin-bottom: 30px;
    color: #a11128;
}

.fire-stations-page {
    padding-top: 20px;
}
</style>